import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/blog/[id]/BlogDetailClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/components/13Footer/FooterWrapper.jsx");
